export const getApiUrl = () => {
	if (import.meta.env.VITE_API_URL) {
		return import.meta.env.VITE_API_URL;
	}
	return `${window.location.protocol}//${window.location.host}`;
};
type Params = {
	[key: string]: string | undefined;
};
export const addParamsToUrl = (base: string, params: Params) => {
	const urlParams = Object.entries(params).reduce((result, [key, value]) => {
		value !== undefined && result.append(key, value);
		return result;
	}, new URLSearchParams());
	const separator = base.indexOf("?") >= 0 ? "&" : "?";
	return `${base}${separator}${urlParams.toString()}`;
};

// Apple requires managementURL and tokenNotificationURL to be https. Accepts a
// bare domain ("shop.example.com") and normalizes it, which is the shape of
// dintero_psp.applepay.details.domain_names.
export const toHttpsUrl = (value?: string): string | undefined => {
	if (!value) {
		return undefined;
	}
	const candidate = value.includes("://") ? value : `https://${value}`;
	try {
		const url = new URL(candidate);
		return url.protocol === "https:" ? url.toString() : undefined;
	} catch {
		return undefined;
	}
};
